import querystring from "query-string";
import axiosInstance, { errorHandler } from "./api";

const TRANSACTIONS_URL =
  "/report-service/api/transfer-management/fast-transactions/web-history";

// TransferManagementResource.getWebTransactionsHistory
const getHistory = axios => (
  currency,
  account,
  from,
  to,
  status,
  page,
  size,
  filter = "",
  sort = "",
) =>
  axios
    .get(
      `${TRANSACTIONS_URL}/?${querystring.stringify({
        currency,
        account,
        from,
        to,
        status,
        page,
        size,
        filter,
        sort,
      })}`,
    )
    .then(({ data, headers }) => ({
      data: data.data,
      total: Number(headers["x-total-count"]),
      hasNext: headers["hasnext"] === "true",
      hasPrevious: headers["hasprevious"] === "true",
    }))
    .catch(errorHandler);

// FstIrohaAccountResource.getAllFstIrohaAccountIds
const getAccountsCurrenciesStatuses = axios => () =>
  axios
    .get("/report-service/api/fst-iroha-accounts/list")
    .then(({ data }) => data)
    .catch(errorHandler);

// FstIrohaAccountResource.getAllMobileIrohaAccounts
const getMobileAccountsCurrenciesStatuses = axios => () =>
  axios
    .get("/tps/api/v2/fst-iroha-accounts/mobile/")
    .then(({ data }) => data)
    .catch(errorHandler);

// FstIrohaAccountResource.findAccountIdsStartingWith
const searchAccount = axios => (
  startLetters = "",
  page = 0,
  size = 10,
  sort = "",
) =>
  axios
    .get("/report-service/api/fst-iroha-accounts/account-id-starting-with", {
      params: {
        startLetters,
        page,
        size,
        sort,
      },
    })
    .then(({ data }) => data.content);

export default {
  getHistory: getHistory(axiosInstance),
  searchAccount: searchAccount(axiosInstance),
  getAccountsCurrenciesStatuses: getAccountsCurrenciesStatuses(axiosInstance),
  getMobileAccountsCurrenciesStatuses: getMobileAccountsCurrenciesStatuses(
    axiosInstance,
  ),
};
